import React from 'react';

const Select = ({items, placeholder, onChange, withAll, selectedValue, index}) => {
  return (
    <select className="form-control" id={`form-selected-${index}`} placeholder={placeholder} onChange={onChange} defaultValue={selectedValue}>
      {withAll ? (<option value="all">...</option>) : null}
      {items.map((element) => {
        return (
          <option value={element.alias} key={element.alias}>
            {element.name.ru}
          </option>
        );
      })}					
		</select>
  );
};

export default Select;
